import React from "react";
import "./styles.scss";

const JioimmerseAndroidTnc = () => {
  return (
    <>
      <div
        className="tnc-jioimmerse-wrapper"
        spellCheck="false"
        contentEditable="false"
      >
        <div className="tnc-jioimmerse-wrapper-info">
          <h2 id="tnc-jioimmerse-wrapper-inner" role="heading" aria-level="2">Terms of use&nbsp;</h2>
        </div>

        <ul className="tnc-jioimmerse-wrapper-content">
          <li>
            This Terms of Use along with the Privacy Policy ("Terms"), is a
            binding agreement between Jio Platforms Limited (we/us/our/JPL) and
            the end user who access or avail the Application (defined below) and
            the Content in accordance with this Terms ("you"/"your") of the
            Application (defined below). The Terms are an electronic record in
            terms of the Information Technology Act, 2000 (as amended /
            re-enacted) (“IT Act") and rules thereunder, and is published in
            accordance with the provisions of Rule 3 (1) (a) of Information
            Technology (Intermediary Guidelines and Digital Media Ethics code)
            Rules, 2021, which mandates for publishing of rules and regulations,
            privacy policy and terms of use for access or usage of Application.
            This electronic record is generated by a computer system and does
            not require any physical or digital signatures.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-content">
          <li>
            BY CLICKING ON THE "I ACCEPT" BUTTON AT THE END OF THE TERMS, OR
            OTHERWISE HAVING ACCESS TO, RECEIVING, AND/OR USING THE JIOIMMERSE
            APPLICATION ("APPLICATION"), YOU HEREBY CONFIRM TO HAVE READ,
            UNDERSTOOD AND AGREE TO BE GOVERNED AND BOUND BY, THIS TERMS AND THE
            PRIVACY POLICY ("POLICY") WHICH IS INCORPORATED BY REFERENCE AND
            FORMS PART OF TERMS AND ANY OTHER RULES OR GUIDELINES, AS MAY BE
            ISSUED BY JIO PLATFORMS LIMITED WITH RESPECT TO THE APPLICATION,
            FROM TIME TO TIME. YOU MAY ACCESS THE PRIVACY POLICY IN SUPPORT
            SECTION. SINCE ALL THE TERMS AND CONDITIONS AS MENTIONED HEREUNDER
            ARE PIVOTAL TO JIO PLATFORMS LIMITED PROVIDING YOU ACESS TO THIS
            APPLICATION IF YOU DO NOT AGREE TO BE BOUND BY THE TERMS, PLEASE DO
            NOT CLICK THE "I ACCEPT" BUTTON OR DOWNLOAD OR INSTALL/USE THE
            APPLICATION.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li>
            Jio Platforms Limited reserves the right to modify the Terms at any
            time at its sole discretion, with notice to you. You will be deemed
            to have accepted the terms of these Terms, as amended, if you
            continue to access the Application after the Terms are modified and
            notified to you. Discontinuing use of this Application will not
            affect the applicability of the Terms to your prior uses of the
            Application.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li>
            You acknowledge and confirm that Jio Platforms Limited is merely
            acting as a passive conduit to facilitate the availability of the
            Content and therefore Jio Platforms Limited is an intermediary under
            the Information Technology Act, 2000 as amended and the relevant
            rules made thereunder. This Terms is deemed to be published and
            shall be construed in accordance with the provisions of Information
            Technology (Intermediary Guidelines and Digital Media Ethics Code)
            Rules, 2021 under Information Technology Act, 2000 that require
            publishing the rules and regulations, privacy policy and user
            agreement for access or usage of the Content.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <h2>1. Registration:&nbsp;</h2>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">1.1&nbsp;</li>
          <li>
            In order to access any information, Content to which you may have
            authorized access to as part of, or through your use of, the
            Application, you will be required to download and install the
            Application on your Device (defined below). This Application has
            been devised for usage along with the Jio Dive product and other
            augmented reality/ virtual reality/ mixed reality products made
            available by affiliates of Jio Platform Limited.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">1.2&nbsp;</li>
          <li>
            If you are under the age of 18 years, you should review this Terms
            with your parent or legal guardian to make sure that you and your
            parent or legal guardian understand and agree to it and further if
            required your parent / legal guardian shall perform or undertake
            such activities to enter into a legally binding agreement with Jio
            Platforms Limited.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">1.3&nbsp;</li>
          <li>
            In order to access and use the Content, you are required to create a
            user account with Jio Platforms Limited for the Application. You
            agree not to reveal your user account information to anyone. You are
            solely responsible for maintaining the confidentiality and security
            of your user account and for all activities that occur on or through
            your user account. You agree to immediately notify Jio Platforms
            Limited of any security breach of your user account. Jio Platforms
            Limited shall not be responsible for any losses arising out of the
            unauthorized use of your user account. You confirm and warrant that
            all the data and information supplied by you when you register for
            accessing the Website and provided by you to Jio Platforms Limited
            is true, current, complete and accurate in all respects.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">1.4&nbsp;</li>
          <li>
            You may at the sole discretion of Jio Platforms Limited be permitted
            to write comments/reviews/feedback regarding the Content on social
            networking websites through the social networking capabilities
            incorporated in the Application. You shall not post any unlawful,
            threatening, abusive, libellous, defamatory, obscene, vulgar,
            pornographic, profane or indecent information of any kind,
            including, without limitation, any comments/reviews/feedback
            constituting or encouraging conduct that would constitute a criminal
            offence, give rise to civil liability or otherwise violate any
            local, state, national or international law or regulation. You give
            Jio Platforms Limited express rights and consent to display your
            rating / review in relation to the relevant Content on the
            Application/website, including making it available to other members
            for viewing. These features may change without notice to you and the
            degrees of associated information sharing and functionality may also
            change without notice.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">1.5&nbsp;</li>
          <li>
            Jio Platforms Limited is free at its sole discretion to use any
            comments, information, ideas, concepts, reviews, or techniques or
            any other material contained in any communication you may send to us
            ("User Feedback"), including responses to questionnaires or through
            postings to the Application and user submissions, without further
            compensation, acknowledgement or payment to you for any purpose
            whatsoever including, but not limited to, developing, manufacturing
            and marketing products and creating, modifying or improving the Jio
            Platforms Limited’s offerings including Application. By posting /
            submitting any User Feedback / user submission on the Application,
            you grant Jio Platforms Limited a perpetual, worldwide,
            non-exclusive, royalty-free irrevocable, sub-licensable license and
            right in such User Feedback / user submission to Jio Platforms
            Limited, including the right to display, use, reproduce, or modify
            the User Feedback / user submission in any media, software or
            technology of any kind now existing or developed in the future. Jio
            Platforms Limited reserves the right to remove User Feedback / user
            submission at sole discretion and/or upon on request of any third
            party that such User Feedback / user submission may create liability
            for Jio Platforms Limited or harm the reputation of Jio Platforms
            Limited or are offensive, inappropriate, defamatory, obscene or
            libelous in nature.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <h2>2. Communication and Unsubscription:</h2>
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">2.1&nbsp;</li>
          <li>
            You understand that once you have shared your user account
            information and successfully registered on the Application, you may
            receive SMS or email notifications from Jio Platforms Limited
            relating to your registration and transactions on the Application.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">2.2&nbsp;</li>
          <li>
            You may also receive such notifications regarding any marketing /
            promotional activities that maybe available on the Application from
            time to time. By accepting these Terms, you explicitly consent to
            receive news, updates, offers/ campaign, marketing/ promotional
            communications (through call, SMS, email or other digital and
            electronic means) from us and/or our authorized representatives
            regarding any new services or offerings, even if your contact number
            is registered under the DND/NCPR list under the Telecom Commercial
            Communications Customer Preference Regulations, 2018.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">2.3&nbsp;</li>
          <li>
            You can unsubscribe / opt-out from receiving marketing/ promotional
            communications, newsletters and other notifications from us at any
            time by following the instructions set out in such communications.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <h2>3. Grant of License:</h2>
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">3.1&nbsp;</li>
          <li>
            <span style={{ fontFamily: "JioType-Bold" }}>
              Software License:&nbsp;
            </span>
            You hereby agree that all rights, title and interests in the
            Application vest with Jio Platforms Limited or its licensors.
            Subject to your strict and full compliance with the Terms, Jio
            Platforms Limited hereby grants you a revocable, non-exclusive,
            non-transferable, non-sub-licensable, limited license, to download,
            install and use the Application on Devices owned and controlled by
            you, and to access and use the Content only through the Application
            on such Devices, strictly in accordance with the terms of these
            Terms. The Application includes (i) the software application in
            object code/source code that you may access and download and the
            scripts, interfaces, graphics, displays, text, documentation and
            other components/associated data and information made available to
            you as part of the software; and (ii) any updates, modifications, or
            enhancements to (i) or any part thereof, as may be provided by Jio
            Platforms Limited.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">3.2&nbsp;</li>
          <li>
            <span style={{ fontFamily: "JioType-Bold" }}>
              Content License:&nbsp;
            </span>
            "Content" shall include all visual and audio-visual works, including
            all interactive content, texts, photographs, software development
            kits, mini-applications etc., made available to you through the
            Application. The Content is either owned by Jio Platforms Limited or
            by third party content providers as indicated on the Application.
            Subject to your strict and full compliance with the Terms, Jio
            Platforms Limited, hereby grants you for the territory of India a
            personal, limited, non-exclusive, non-transferable, revocable
            license to use the Content for your private and personal use and
            non-commercial viewing and/or streaming, through your Device in
            accordance with the Terms.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">3.3&nbsp;</li>
          <li>
            Except for the rights expressly stated herein, no other rights are
            granted to you with respect to the Application or the Content,
            either by implication, estoppel, or otherwise.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <h2>
              4. Terms of Accessing the Application and the Content:
            </h2>
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">4.1&nbsp;</li>
          <li>
            The Application is merely intended as a means to make the Content
            available. Your access to the Application and the Content signifies
            your consent to view / receive all such Content. You agree and
            acknowledge that by use of the Application, you do not acquire
            ownership in the Application or the Content. You shall view the
            Content only by way of streaming/download or any other functionality
            provided by the Application only. You agree to view the Content for
            your personal, non-commercial use only, and strictly in the manner
            permitted under this Terms.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">4.2&nbsp;</li>
          <li>
            Application and all Content, including all text, graphics,
            trademarks, logos, photographs, audio visual content, and other
            material made available through the Application constitutes material
            proprietary to Jio Platforms Limited or its content providers as
            indicated on the Application, and is protected by applicable
            intellectual property laws, and may not be used by You, except as
            permitted by Jio Platforms Limited.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">4.3&nbsp;</li>
          <li>
            Use of the Application requires: (i) compatible devices such as
            smart phones powered by Android and iOS ("Device"), (ii) JioDive
            product and/ or other augmented reality/ virtual reality/ mixed
            reality products made available by affiliates of Jio Platform
            Limited and (iii) Internet access. Further, certain software (fees
            may apply), in your Device or in the Application may require
            periodic updates and use of the Application along with its
            performance may be affected by the performance of these factors.
            High-speed Internet access is strongly recommended for regular use.
            The latest version of the Application is recommended to access the
            Content and may be required for certain transactions or features.
            You agree that meeting these requirements, which may change from
            time to time, is your responsibility.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">4.4&nbsp;</li>
          <li>
            From time to time, and without prior notice to you, Jio Platforms
            Limited may provide updates of the Application, or may issue
            upgraded versions of the Application. However, Jio Platforms Limited
            shall be under no obligation to do so. All updates/upgrades provided
            by Jio Platforms Limited will be subject to the terms of this Terms.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">4.5&nbsp;</li>
          <li>
            The Application may contain the links or pointers to other websites/
            applications, but you should not infer or assume that Jio Platforms 
            Limited operates, controls, or is otherwise connected with these other
            websites/applications. When you click on a link within the Application, Jio
            Platforms Limited may not warn you that you have left the
            Application and are subject to the terms and conditions (including
            privacy policies) of another website/ application. Please be careful to read the
            terms of use and privacy policy of any other website/application before you
            provide any confidential information or engage in any transactions.
            You should not rely on this Terms to govern your use of another
            website. Jio Platforms Limited is not responsible for the content or
            practices, updates, or modifications, of any other website/application even 
            if it links to the Application or even if the website/application is operated by a 
            company affiliated or otherwise connected with Jio Platforms Limited. 
            You acknowledge and agree that Jio Platforms Limited is not responsible or 
            liable to you for any content or other materials hosted and served from any website/application
            other than the Application.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">4.6&nbsp;</li>
          <li>
            You acknowledge that using/viewing any content of JioHotstar made available in the Application shall be governed as per 
            <a href="https://www.hotstar.com/tnc/in" target="_blank" rel="noopener noreferrer">JioHotstar’s Terms & Conditions</a> 
            and 
            <a href="https://www.hotstar.com/privacy-policy/in" target="_blank" rel="noopener noreferrer">Privacy Policy</a> 
            (as updated from time to time)
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <h2>
              5. Restrictions on use of the Application and the Content:{" "}
            </h2>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">5.1&nbsp;</li>
          <li>
            You shall use the Application strictly in accordance with this Terms
            and shall not: (i) decompile, disassemble, reverse engineer or
            attempt to derive the source code of or in any manner decrypt the
            Application; (ii) make any modification, adaptation or improvement,
            enhancement, or derivative work from the Application or incorporate
            any portion of the software into your own programs or compile any
            portion of it in combination with your own programs, transfer it for
            use with another service; (iii) violate any applicable laws or
            regulations including but not limited to copyright act, import and
            export control laws and regulations in connection with your access
            or use of the Application or the Content; (iv) remove or obscure any
            proprietary notice (including any notice of copyright or trademark)
            forming a part of the Application or the Content; (v) use the
            Application or the Content for any revenue generation endeavor, or
            any other purpose for which it is not designed or intended; (vi)
            install, use or permit the Application to exist on more than one
            Device at a time or on any other applicable device, other than by
            means of your separate downloads of the Application, each of which
            is subject to a separate license; (vii) distribute or link the
            features being provided to multiple devices, or other features;
            (viii) make available the Application over a network or other
            environment permitting access or use by multiple users at the same
            time or where it could be used by multiple devices at the same time,
            whether or not the same is for commercial use; (ix) use the
            Application for data mining, scraping, crawling, redirecting, or for
            any purpose not in accordance with the terms of these Terms; (x) use
            the Application to attempt to interfere with the proper display of
            the Content; (xi) use the Application for undertaking any hacking
            activities like breaching or attempt to breach the security of
            another user or attempt to gain access to any other person's
            computer, software or data without the knowledge and consent of such
            person; (xii) use the Application for creating a service or software
            that is directly or indirectly, competitive with the Application or
            any features offered by Jio Platforms Limited; or (xiii) derive any
            confidential information, processes, data or algorithms from the
            Application.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">5.2&nbsp;</li>
          <li>
            You also expressly agree not to engage in any use or activity that
            (a) may interrupt, destroy, alter, damage, delay, or limit the
            functionality or integrity of the Application or the Content
            including that of, any associated software, hardware,
            telecommunications or wireless equipment; (b) may manipulate
            identifiers, or numeric information to disguise the origin of any
            user, device, material or other information; (c) may interfere with
            the proper working of the Application or prevent others from using
            the Application; or (d) may delete the copyright and other
            proprietary rights notices on the Application.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">5.3&nbsp;</li>
          <li>
            You agree not to use the Application for any activity relating to
            infringement of any intellectual property rights, including any
            trademarks, service marks, or trade names, privacy rights,
            personality rights, or any other proprietary rights of any third
            party. You shall not use the Application and access the Content
            through the Application outside the territory of the Republic of
            India, unless permitted by Jio Platforms Limited. Jio Platforms
            Limited shall have the right to use various technologies and digital
            rights management mechanisms to enforce this territorial restriction
            and/or to verify your compliance with this restriction.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">5.4&nbsp;</li>
          <li>
            Nothing contained herein shall be construed or implied to grant any
            right or license to use any trademarks, trade names, service marks
            or logos, which are a part of the Application or the Content,
            without the prior written consent of the owner of rights in such
            marks.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">5.5&nbsp;</li>
          <li>
            You agree not to incorporate the Content into, or stream or
            retransmit the Content via, any hardware or software application or
            make it available via frames or in-line links unless expressly
            permitted by Jio Platforms Limited.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">5.6&nbsp;</li>
          <li>
            You shall not access the Content by any means other than through the
            Application. You shall, unless explicitly provided herein, neither
            directly nor through the use of any device, software, web-based
            service, or other means copy, download, stream capture, reproduce,
            duplicate, archive, distribute, upload, publish, / re-publish,
            modify, translate, broadcast, perform, publicly display, sell,
            transmit or retransmit, edit, re-use, adapt, incorporate or create
            any derivative works of, any Content streamed / viewed / downloaded
            from the Application.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">5.7&nbsp;</li>
          <li>
            You must not access the Application if you are a person who is
            either barred or otherwise legally prohibited from receiving or
            using the Service or any Services under the laws of India.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">5.8&nbsp;</li>
          <li>
            You shall not host, display, upload, modify, publish, transmit,
            update or share any information on Application or any other links
            available on Application, which:
          </li>
        </ul>

        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">a)</li>
          <li role="presentation" style={{ marginTop: "1rem !important;" }}>
            &nbsp;Belongs to another person and to which you do not have any
            right to;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation" style={{ marginLeft: "1rem !important;" }}>
            b)&nbsp;
          </li>
          <li role="presentation">
            Is obscene, pornographic, paedophilic, invasive of another‘s privacy, including bodily privacy, insulting or harassing on the basis of gender, libellous, racially or ethnically objectionable, relating or encouraging money laundering or gambling, or an online game that causes user harm, or promoting enmity between different groups on the grounds of religion or caste with the intent to incite violence;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">c)</li>
          <li role="presentation" style={{ marginTop: "-1rem !important;" }}>
            &nbsp;Deceives or misleads the addressee about the origin of the message or knowingly and intentionally communicates any misinformation or information which is patently false and untrue or misleading in nature or, in respect of any business of the Central Government, is identified as fake or false or misleading by such fact check unit of the Central Government as the Ministry may, by notification published in the Official Gazette, specify;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">d)</li>
          <li role="presentation" style={{ marginTop: "-1rem !important;" }}>
            &nbsp;Is patently offensive to the online community, such as
            sexually explicit content, or content that promotes obscenity,
            pedophilia, racism, bigotry, hatred or physical harm of any kind
            against any group or individual;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">e)</li>
          <li role="presentation" style={{ marginTop: "-1rem !important;" }}>
            &nbsp;Harassing or advocates harassment of another person;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">f)</li>
          <li role="presentation" style={{ marginTop: "-1rem !important;" }}>
            &nbsp;Involves the transmission of “junk mail”, “chained letters”,
            or unsolicited mass mailing or “spamming”;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">g)</li>
          <li role="presentation" style={{ marginTop: "-1rem !important;" }}>
            &nbsp;Promotes illegal activities;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">h)</li>
          <li role="presentation" style={{ marginTop: "-1rem !important;" }}>
            &nbsp;Infringes any patent, trademark, copyright or other proprietary rights;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">i)</li>
          <li role="presentation" style={{ marginTop: "-1rem !important;" }}>
            &nbsp;i) Is in the nature of advertisement or surrogate advertisement or promotion of an online game that is not a permissible online game, or of any online gaming intermediary offering such an online game;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">j)</li>
          <li role="presentation" style={{ marginTop: "-1rem !important;" }}>
            &nbsp;Provides instructional information about illegal activities
            such as making and/ or buying illegal weapons, violating someone’s
            privacy, or providing or creating computer viruses;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">k)</li>
          <li role="presentation" style={{ marginTop: "-1rem !important;" }}>
            &nbsp;Solicits gambling or engages in any gambling activity which we
            in our sole discretion believe is or could be construed to be as
            illegal;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">l)</li>
          <li role="presentation" style={{ marginTop: "-1rem !important;" }}>
            &nbsp;Is harmful to child;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">m)</li>
          <li role="presentation" style={{ marginTop: "-1rem !important;" }}>
            &nbsp;Violates any law for the time being in force;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">n)</li>
          <li role="presentation" style={{ marginTop: "-1rem !important;" }}>
            &nbsp;Impersonates another person;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">o)</li>
          <li role="presentation" style={{ marginTop: "-1rem !important;" }}>
            &nbsp;Contains software viruses or any other computer code, files or
            programs designed to interupt, destroy or limit the functionality of
            any computer resource; or contains any trojan horses, worms, time
            bombs, cancelbots, easter eggs or other computer programming
            routines that may damage, detrimentally interfere with, diminish
            value of, surreptitiously intercept or expropriate any system, data or
            personal information;
          </li>
        </ul>
        <ul
          className="tnc-jioimmerse-wrapper-content"
          style={{ marginLeft: "1rem", marginTop: "10px" }}
        >
          <li role="presentation">p)</li>
          <li role="presentation" style={{ marginTop: "-1rem !important;" }}>
            &nbsp;Threatens the unity, integrity, defence, security or
            sovereignty of India, friendly relations with foreign states, or
            public order or causes incitement to the commission of any
            cognizable offense or prevents investigation of any offense or is
            insulting any other nation;
          </li>
        </ul>

        {/*  */}
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">5.9&nbsp;</li>
          <li>
            You agree not to, or permit anyone else to, circumvent, disable or
            otherwise interfere with security-related features and any digital
            rights management mechanisms of the Application including the
            features that prevent or restrict use or copying of any Content
            provided to you through the Application. You agree that Jio
            Platforms Limited shall have no liability for, and you agree to
            defend, indemnify and hold Jio Platforms Limited harmless against,
            any claims, losses or damages arising out of, or in connection with,
            your unauthorized use of any Content and/or Application.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">5.10&nbsp;</li>
          <li>
            Jio Platforms Limited does not endorse any Content made available
            through the Application, or any opinion, recommendation, or advice
            expressed thereon by any user and Jio Platforms Limited expressly
            disclaims any and all liability in connection with such views or
            opinions or comments provided by the users.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">5.11&nbsp;</li>
          <li>
            Jio Platforms Limited shall use reasonable efforts to make the
            Content available to the users, at all times through the
            Application. However, the Content is provided over the Internet,
            data and cellular networks and so the quality and availability of
            the same may be affected by factors outside Jio Platforms Limited’s
            control. Accordingly, Jio Platforms Limited does not accept any
            responsibility for unavailability of the Application and/or Content,
            at any time. Jio Platforms Limited will not be responsible for any
            support or maintenance for the Application.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">5.12&nbsp;</li>
          <li>
            Part of the Application may contain advertising information or
            promotion material or other material submitted to the Jio Platforms
            Limited by third parties. Responsibility for ensuring that material
            submitted for inclusion on the Application complies with applicable
            national law is exclusively on the party providing the
            information/material. Your correspondence or business dealings with,
            or participation in promotions of advertisers including payment and
            delivery of related goods or services, and any other terms,
            conditions, warranties or representations associated with such
            dealings, are solely between you and such advertiser. Before relying
            on any advertising material, you should independently verify its
            relevance for your purpose, and should obtain appropriate
            professional advice. Jio Platforms Limited shall not be responsible
            nor liable for any loss or claim that you may have against an
            advertiser or any consequential damages arising on account of you
            relying on the contents of the advertisement.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">5.13&nbsp;</li>
          <li>
            JIO PLATFORMS LIMITED DISCLAIMS ANY AND ALL RESPONSIBILITY FOR ANY
            DISCLOSURE OF INFORMATION OR ANY OTHER PRACTICES OF ANY THIRD PARTY.
            JIO PLATFORMS LIMITED EXPRESSLY DISCLAIMS ANY WARRANTY WITH RESPECT
            TO YOUR PERSONAL OR OTHER INFORMATION THAT MAY BE COLLECTED,
            PROCESSED, SHARED OR RETAINED BY ANY THIRD PARTY.
          </li>
        </ul>

        {/* 5th  */}
        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <h2>6. Rights of Jio Platforms Limited:</h2>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">6.1&nbsp;</li>
          <li>
            Jio Platforms Limited, in its sole discretion, may terminate or
            suspend your access to the Content without any obligation to serve
            any prior notice and without any obligations or liabilities towards
            you or towards any third parties, except as provided under Clause
            5.6 above.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">6.2&nbsp;</li>
          <li>
            Upon your breach of this Terms, the Policy or any other restrictions
            or guidelines of Jio Platforms Limited for use of the Application
            and/or accessing any of the Content, Jio Platforms Limited reserves
            the right to take any responsive actions which Jio Platforms Limited
            may deem appropriate. Such actions may include (but may not be
            limited to) temporary or permanent removal of Content, termination
            of your immediate suspension or cancellation of your access to the
            Content via the Application.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">6.3&nbsp;</li>
          <li>
            Jio Platforms Limited may take any other legal or technical action
            against you that Jio Platforms Limited may deem appropriate,
            including any action against offenders to recover the costs and
            expenses of identifying them.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">6.4&nbsp;</li>
          <li>
            Jio Platforms Limited may directly or through third party service
            providers send information to you about the various services offered
            by the Jio Platforms Limited from time to time.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <h2>7. Indemnity:</h2>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">7.1&nbsp;</li>
          <li>
            You shall defend, indemnify and hold harmless, Jio Platforms
            Limited, its affiliates, any third party networks / infrastructure
            providers and their respective directors, officers, personnel,
            contractors and agents, for and against any and all claims, suits,
            judgment, losses, damages, cost and expenses arising or relating to
            your use of the Application and/or the Content or your breach of the
            terms of these Terms or the Policy or any other restrictions or
            guidelines provided by Jio Platforms Limited. This indemnification
            obligation will survive this Terms and Your use of the Application /
            Content.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <h2>8.Disclaimer of Warranties:&nbsp;</h2>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">8.1&nbsp;</li>
          <li>
            THE APPLICATION AND ALL CONTENT PROVIDED THROUGH THE APPLICATION, IS
            PROVIDED ON AN "AS-IS" AND "WITH ALL FAULTS AND RISKS" BASIS,
            WITHOUT WARRANTIES OF ANY KIND. JIO PLATFORMS LIMITED DOES NOT
            WARRANT, EXPRESSLY OR BY IMPLICATION, THE ACCURACY OR RELIABILITY OF
            THE APPLICATION OR ANY CONTENT OR ITS SUSTAINABILITY FOR A
            PARTICULAR PURPOSE. TO THE MAXIMUM EXTENT PERMITTED UNDER APPLICABLE
            LAWS, JIO PLATFORMS LIMITED DISCLAIMS ALL WARRANTIES WHETHER EXPRESS
            OR IMPLIED, INCLUDING THOSE OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE, NON-INFRINGEMENT, OR THAT USE OF THE APPLICATION
            AND THE CONTENT OR ANY MATERIAL THEREOF WILL BE UNINTERRUPTED OR
            ERROR-FREE OR THAT ANY CONTENT WILL BE AVAILABLE THROUGHOUT TERM.
            WITHOUT LIMITING THE GENERALITY OF THE FOREGOING, JIO PLATFORMS
            LIMITED DOES NOT REPRESENT OR WARRANT THAT THE APPLICATION WILL
            RESULT IN COMPLIANCE, FULFILLMENT OR CONFORMITY WITH THE LAWS,
            REGULATIONS, REQUIREMENTS OR GUIDELINES OF ANY GOVERNMENT OR
            GOVERNMENTAL AGENCY.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">8.2&nbsp;</li>
          <li>
            To the maximum extent permitted by applicable law, Jio Platforms
            Limited provides no warranty on use of the Content and shall not be
            liable for the same under intellectual property rights, libel,
            privacy, publicity, obscenity or other laws. Jio Platforms Limited
            also disclaims all liability with respect to the misuse, loss,
            modification or unavailability of any Content.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <h2>9.Limitation of Liability:</h2>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">9.1&nbsp;</li>
          <li>
            YOU ASSUME THE ENTIRE RISK OF USING THE APPLICATION AND THE CONTENT.
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL
            JIO PLATFORMS LIMITED BE LIABLE TO YOU FOR ANY SPECIAL, INCIDENTAL,
            INDIRECT, PUNITIVE OR CONSEQUENTIAL DAMAGES WHATSOEVER (INCLUDING,
            WITHOUT LIMITATION, DAMAGES FOR LOSS OF USE, LOSS OF BUSINESS
            PROFITS, BUSINESS INTERRUPTION, LOSS OF INFORMATION, OR ANY OTHER
            PECUNIARY LOSS) ARISING OUT OF THE USE OF, OR INABILITY TO USE OR
            ACCESS, THE APPLICATION OR THE CONTENT OR FOR ANY SECURITY BREACH OR
            ANY VIRUS, BUG, UNAUTHORIZED INTERVENTION, DEFECT, OR TECHNICAL
            MALFUNCTIONING OF THE APPLICATION, WHETHER OR NOT FORESEEABLE OR
            WHETHER OR NOT Jio Platforms Limited HAS BEEN ADVISED OF THE
            POSSIBILITY OF SUCH DAMAGES, OR BASED ON ANY THEORY OF LIABILITY,
            INCLUDING BREACH OF CONTRACT OR WARRANTY, NEGLIGENCE OR OTHER
            TORTIOUS ACTION, OR ANY OTHER CLAIM ARISING OUT, OF OR IN CONNECTION
            WITH, YOUR USE OF, OR ACCESS TO, THE APPLICATION OR THE CONTENT.
            FURTHER, JIO PLATFORMS LIMITED SHALL NOT BE LIABLE TO YOU FOR ANY
            TEMPORARY DISABLEMENT, PERMANENT DISCONTINUANCE OR MODIFICATION OF
            THE APPLICATION BY JIO PLATFORMS LIMITED OR FOR ANY CONSEQUENCES
            RESULTING FROM SUCH ACTIONS.
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">9.2&nbsp;</li>
          <li>
            JIO PLATFORMS LIMITED’S AGGREGATE LIABILITY (WHETHER UNDER CONTRACT,
            TORT INCLUDING NEGLIGENCE, WARRANTY OR OTHERWISE) AND THAT OF ITS
            AFFILIATES SHALL BE LIMITED TO RUPEES HUNDRED (Rs. 100).
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <h2>10. Governing Law:&nbsp;</h2>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">10.1&nbsp;</li>
          <li>
            This Terms is governed and construed in accordance with the laws of
            India. The courts in Mumbai shall have exclusive jurisdiction to
            hear disputes arising out of the Terms.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <h2>11. Force Majeure:</h2>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">11.1&nbsp;</li>
          <li>
            Jio Platforms Limited shall be under no liability whatsoever in the
            event of non-availability of any portion of the Application or
            subscribed Content occasioned by act of God, war, disease,
            revolution, riot, civil commotion, strike, lockout, flood, fire,
            failure of any public utility, man-made disaster, infrastructure
            failure or any other cause whatsoever beyond the control of Jio
            Platforms Limited.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <h2>
              12. Copyright Notice and Notice for other Grievances:
            </h2>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">12.1&nbsp;</li>
          <li>
            In accordance with the applicable laws, for any grievance including
            if, you believe in good faith that the Content or any information
            viewed through the Application infringes your copyright, you may
            reach us at 
            <br />
            <u>grievance.officer@jio.com </u>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">&nbsp;12.2&nbsp;</li>
          <li>
            You may forward your request/ complaints to Grievance Officer.
            <br /> Name: Radha Nair <br />
            Contact: E-mail:  <u>grievance.officer@jio.com </u>
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <h2>13. Waiver:</h2>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">&nbsp;13.1&nbsp;</li>
          <li>
            Any failure by Jio Platforms Limited to enforce the Terms, for
            whatever reason, shall not necessarily be construed as a waiver of
            any right to do so at any time.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <h2>14. Severability:</h2>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">&nbsp;14.1&nbsp;</li>
          <li>
            If any of the provisions of this Terms are deemed invalid, void, or
            for any reason unenforceable, that part of the Terms will be deemed
            severable and will not affect the validity and enforceability of any
            remaining provisions of the Terms.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <h2>15. Entire Agreement:</h2>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">&nbsp;15.1&nbsp;</li>
          <li>
            The Terms including the Policy, as amended from time to time,
            constitutes the entire agreement between the parties and supersedes
            all prior understandings between the parties relating to the subject
            matter herein.
          </li>
        </ul>

        <ul className="tnc-jioimmerse-wrapper-ul_style">
          <li role="presentation">
            <h2>16. Limited Time To Bring Your Claim:</h2>
          </li>
        </ul>
        <ul className="tnc-jioimmerse-wrapper-content">
          <li role="presentation">&nbsp;16.1&nbsp;</li>
          <li>
            You and Jio Platforms Limited agree that any cause of action arising
            out of or related to use of the Application or the Content must
            commence within one (1) year after the cause of action accrues
            otherwise, such cause of action will be permanently barred.
          </li>
        </ul>
      </div>
    </>
  );
};

export default JioimmerseAndroidTnc;
